import angular, { IScope } from 'angular';
import { FilterService2 } from '../../tn.common';
import { ILicenseFilters, LicenseService } from '../../tn.licenses/license.service/license-service';

ProjectDetailFilters.$inject = [
    '$scope',
    'tnFontFilterService',
    'tnLicenseService',
];

export function ProjectDetailFilters(
    $scope: IScope,
    filterService: FilterService2,
    licenseService: LicenseService
): void {
    const vm = angular.extend(this, {
        activeFilters: filterService.get(),
        clearFilter: (name) => filterService.reset(name),
        clearFilters: resetAll,
        hasFilter: (name, value) => filterService.hasFilter(name, value),
        isActive: { expiration: true, licenseType: true },
        licenses: licenseService.get(),
        filteredLicenses: licenseService.getFilteredLicenses(),
        toggleFilter: (name, obj) => filterService.toggle(name, obj),
    });

    $scope.$watch(
        'vm.activeFilters',
        function (newFilters: ILicenseFilters) {
            licenseService.setFilteredLicenses(newFilters);
        },
        true
    );

    $scope.$watch(
        'vm.licenses',
        function (newLicenses) {
            _countExperations(newLicenses);
        },
        true
    );

    vm.expirations = {
        Active: { id: 'Active', count: 0 },
        Expired: { id: 'Expired', count: 0 },
    };

    function resetAll() {
        // Reset everything but the licenseType field
        vm.clearFilter('name');
        vm.clearFilter('expiration');
    }

    function _countExperations(licenses) {
        vm.expirations.Active.count = licenses.filter(function (license) {
            return license.fontRights.web && license.fontRights.web.active;
        }).length;

        vm.expirations.Expired.count = licenses.filter(function (license) {
            return license.fontRights.web && !license.fontRights.web.active;
        }).length;
    }
}
